import '../css/error.css';

const NoPage = () => {
  return (
    <>
      <div className='no-page-container'>
        <h1>404 Error - Page not found</h1>
        <h1>We don't know this page... If you know, let us know, so we know and can let other people know?</h1>
      </div>
    </>
  );
};

export default NoPage;
